import { Stack, Card, CardContent, Typography, Fab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useTheme } from "@mui/material/styles";
import { ReactNode, SetStateAction } from "react";
import { Dispatch } from "react";
import moment from "moment";

export interface Tournament {
  tournament_id: number;
  tournament_name: string;
  league_name: string;
  tournament_date: string;
  tournament_end_date: string;
  handicap: number;
  team_maximum: number;
  team_count: number;
  signups_open: boolean;
  id: number;
  time: string;
  date: string;
  raw_date: Date;
  end_date: Date;
  leagues: League[];
}

export interface League {
  league_name: string;
  handicap: number;
  signups_open: boolean;
  tournament_id: number;
}

function IndividualTournament({
  tournament,
  managerMode,
  setEventId,
  clubId,
  setClubId,
  setLeasePrice,
  setGameDate,
  setGamePoloType,
  setEventToEdit,
  setDisplayTournamentModal,
  setEventDetails,
  weekAtAGlance,
  clubBadge,
}: {
  tournament: Tournament;
  managerMode: number;
  setEventId: (id: number) => void;
  clubId: number;
  setClubId: (id: number) => void;
  setLeasePrice: (price: number) => void;
  setGameDate: (date: string) => void;
  setGamePoloType: (gameType: string) => void;
  setEventToEdit: any;
  setDisplayTournamentModal: Dispatch<SetStateAction<boolean>>;
  setEventDetails: Dispatch<SetStateAction<Tournament>>;
  weekAtAGlance: boolean;
  clubBadge?: ReactNode;
}) {
  let navigate = useNavigate();
  //<Typography color="secondary" variant="h5">{game.event_type}</Typography>
  const theme = useTheme();
  const stylers = {
    backgroundColor: "white",
    color: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: "white",
    },
  };
  
  return (
    <Card
      variant="outlined"
      //style={{ borderColor: "#5D8AA8", borderWidth: "medium", backgroundColor: "rgba(93, 138, 168, 0.55)" }}
      style={{ backgroundColor: "rgba(93, 138, 168, 0.10)" }}
    >
      <CardContent>
        <Stack gap={2}>
          {clubBadge}
          <Stack direction="row" alignItems="center" gap={1}>
            <EmojiEventsIcon color="warning" />
            <Typography variant="body1" color="warning" fontWeight="bold">
              Tournament
            </Typography>
            {<Stack
              direction="row"
              alignItems="center"
              gap={4}
              style={{ marginRight: 0, marginLeft: "auto" }}
            >
              {managerMode === -1 && !weekAtAGlance && (
                <Fab
                  style={stylers}
                  //color="primary"
                  size="small"
                  onClick={() => {
                    console.log(tournament);
                    setEventToEdit(tournament)
                    setDisplayTournamentModal(true)
                  }}
                  //fullWidth={true}
                >
                  <EditIcon />
                </Fab>
              )}
              <Fab
                //variant="contained"
                size="small"
                onClick={() => {
                  if (setClubId) {
                    setClubId(clubId);
                  }
                  setEventId(tournament.id);
                  setGameDate(tournament.date);
                  setEventDetails(tournament);
                  //setLeasePrice(tournament.lessonPrice);
                  //setGamePoloType(tournament.game_type);
                  //if (managerMode === -1) {
                  navigate("/tournamentsignups");
                  //} else {
                  //  navigate("/playergamesignup");
                  //}
                }}
                color="success"
                //disabled={game.available === 0}
                //fullWidth={true}
              >
                <VisibilityIcon />
              </Fab>
            </Stack>}
          </Stack>
          <Stack gap={1}>
            <Stack direction="row">
              <Typography color="primary">{"Tournament Name"}</Typography>
              <Typography style={{ marginRight: 0, marginLeft: "auto" }}>
                {tournament.tournament_name}
              </Typography>
            </Stack>
            <Stack direction="row">
              <Typography color="primary">{"Tournament Dates"}</Typography>
              <Typography style={{ marginRight: 0, marginLeft: "auto" }}>
                {moment(tournament.raw_date).format("MM/DD/YYYY")} - {moment(tournament.end_date).format("MM/DD/YYYY")}
              </Typography>
            </Stack>
            {/*<Stack direction="row">
              <Typography color="primary">{"Time"}</Typography>
              <Typography style={{ marginRight: 0, marginLeft: "auto" }}>
                {tournament.time}
              </Typography>
            </Stack>*/}
              <TableContainer component={Paper} sx={{ ml: 'auto' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: theme.palette.primary.light, color: "white" }}>
                      <TableCell sx={{ color: "white" }}>Leagues</TableCell>
                      <TableCell align="right" sx={{ color: "white" }}>Handicap</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tournament.leagues.map((league: League) => (
                      <TableRow key={league.tournament_id} >
                        <TableCell>{league.league_name}</TableCell>
                        <TableCell align="right">{league.handicap}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default IndividualTournament;
